import { SyntheticEvent } from "react";
import { DateRange } from "src/types.g";

export interface AuditLogFilterProps {
  onChange: (
    event: SyntheticEvent<Element, Event>,
    data: { value: string | boolean | DateRange | null },
  ) => void;
  value: string | null | undefined;
  popoverPosition?: "left" | "right";
}

export const ALL_OPTION = {
  key: "all",
  text: "All",
  value: null,
};
